export const Dropdown = [
  // MASTER ===============================
  {
    id: 1,
    label: "Master",
    dropdownMenu: [
      {
        id: 2,
        label: "Division",
        path: "/master/division",
        slug_create: "master-division-create",
        slug_view: "master-division-view",
        submenu: [],
      },
      {
        id: 3,
        label: "Brand",
        path: "/master/company",
        slug_create: "master-brand-create",
        slug_view: "master-brand-view",
        submenu: [],
      },
      {
        id: 4,
        label: "GST",
        path: "",
        // slug_create: "",
        // slug_view: "",
        slug1: "master-gst-hsn-create",
        slug2: "master-gst-hsn-view",
        slug3: "master-gst-sac-create",
        slug4: "master-gst-sac-view",
        submenu: [
          {
            id: 5,
            label: "HSN Master",
            path: "/master/hsn",
            slug_create: "master-gst-hsn-create",
            slug_view: "master-gst-hsn-view",
          },
          {
            id: 6,
            label: "SAC Master",
            path: "/master/sac",
            slug_create: "master-gst-sac-create",
            slug_view: "master-gst-sac-view",
          },
        ],
      },
      {
        id: 7,
        label: "State",
        path: "/master/state",
        slug_create: "master-state-create",
        slug_view: "master-state-view",
        submenu: [],
      },
      {
        id: 8,
        label: "City",
        path: "/master/city",
        slug_create: "master-city-create",
        slug_view: "master-city-view",
        submenu: [],
      },
      {
        id: 9,
        label: "Item",
        path: "",
        // slug_create: "",
        // slug_view: "",
        slug1: "master-item-category-create",
        slug2: "master-item-category-view",

        slug3: "master-item-materialtype-create",
        slug4: "master-item-materialtype-view",

        slug5: "master-item-itemmaster-create",
        slug6: "master-item-itemmaster-view",

        slug7: "master-item-itembrand-create",
        slug8: "master-item-itembrand-view",
        submenu: [
          {
            id: 10,
            label: "Item Category",
            path: "/master/item-category",
            slug_create: "master-item-category-create",
            slug_view: "master-item-category-view",
          },
          // {
          //   id: 2,
          //   label: "Material Type",
          //   path: "/master/material-type",
          //   slug_create: "master-item-materialtype-create",
          //   slug_view: "master-item-materialtype-view",
          // },
          {
            id: 11,
            label: "Item Master",
            path: "/master/item",
            slug_create: "master-item-itemmaster-create",
            slug_view: "master-item-itemmaster-view",
          },
          {
            id: 12,
            label: "Item with Brand",
            path: "/master/item-with-brand",
            slug_create: "master-item-itembrand-create",
            slug_view: "master-item-itembrand-view",
          },
        ],
      },
      {
        id: 13,
        label: "User Management",
        path: "",
        slug_create: "",
        slug_view: "",
        submenu: [
          {
            id: 14,
            label: "Create Role",
            path: "/master/user-management/create-role",
          },
          {
            id: 15,
            label: "Create User",
            path: "/master/user-management/create-user",
          },
          // {id: 3, label: "Item Master", path: "/master/item" },
          // {id: 4, label: "Item with Brand", path: "/master/item-with-brand" },
        ],
      },
      {
        id: 16,
        label: "Unit",
        path: "/master/unit",
        slug_create: "master-unit-create",
        slug_view: "master-unit-view",
        submenu: [],
      },
      {
        id: 17,
        label: "Party Master",
        path: "/master/supplier",
        slug_create: "master-party-create",
        slug_view: "master-party-view",
        submenu: [],
      },
    ],
  },
  // END- MASTER ===============================

  // PURCHASE ===============================
  {
    id: 18,
    label: "Purchase",
    dropdownMenu: [
      {
        id: 19,
        label: "Indent",
        path: "",
        submenu: [
          { id: 20, label: "Create Indent", path: "/purchase/create-indent" },
          {
            id: 21,
            label: "Indent Approval",
            path: "/purchase/pending-indent-view",
          },
          { id: 22, label: "View Indent", path: "/purchase/view-indent" },
        ],
      },
      {
        id: 23,
        label: "Enquiry",
        path: "",
        submenu: [
          {
            id: 24,
            label: "Generate Enquiry",
            path: "/purchase/generate-enquiry",
          },
          { id: 25, label: "View Enquiry", path: "/purchase/view-enquiry" },
        ],
      },
      {
        id: 26,
        label: "Quotation",
        path: "",
        submenu: [
          {
            id: 27,
            label: "Quotation Enquiry",
            path: "/purchase/quotation-enquiry",
          },
          { id: 28, label: "View Quotation", path: "/purchase/view-quotation" },
        ],
      },
      {
        id: 29,
        label: "Compare Quotation",
        path: "/purchase/compare-quotation",
        submenu: [],
      },
      {
        id: 30,
        label: "PO",
        path: "",
        submenu: [
          {
            id: 31,
            label: "Direct PO Create",
            path: "/purchase/direct-po-create",
          },
          {
            id: 32,
            label: "Indent PO Create",
            path: "/purchase/indent-po-create",
          },
          { id: 33, label: "PO Approval", path: "/purchase/pending-po-view" },
          { id: 34, label: "PO View", path: "/purchase/po-view" },
          // {id: 5, label: "Indent PO View", path: "/purchase/indent-po-view" },
        ],
      },
      {
        id: 35,
        label: "RGP",
        path: "",
        submenu: [
          { id: 36, label: "RGP Create", path: "/purchase/rgp" },
          { id: 37, label: "RGP Approval", path: "/purchase/pending-rgp" },
          { id: 38, label: "View RGP", path: "/purchase/view-rgp" },
        ],
      },
      {
        id: 7,
        label: "NRGP",
        path: "",
        submenu: [
          { id: 39, label: "NRGP Create", path: "/purchase/nrgp" },
          { id: 40, label: "NRGP Approval", path: "/purchase/pending-nrgp" },
          { id: 41, label: "View NRGP", path: "/purchase/view-nrgp" },
        ],
      },
      {
        id: 42,
        label: "Gate Pass",
        path: "",
        submenu: [
          { id: 43, label: "Gate Pass Create", path: "/purchase/gate-pass" },
          { id: 44, label: "GP Approval", path: "/purchase/pending-gp-view" },
          { id: 45, label: "Gate Pass View", path: "/purchase/view-gate-pass" },
        ],
      },
      {
        id: 46,
        label: "GRN",
        path: "",
        submenu: [
          { id: 47, label: "Create GRN", path: "/purchase/grn-create" },
          { id: 48, label: "GRN Approval", path: "/purchase/pending-grn-view" },
          { id: 49, label: "View GRN", path: "/purchase/view-grn" },
        ],
      },
    ],
  },
  // END- PURCHASE ===============================
  // GATE ENTRY START ==================
  {
    id: 50,
    label: "Gate Entry",
    dropdownMenu: [
      {
        id: 51,
        label: "Gate Entry",
        path: "",
        submenu: [
          { id: 52, label: "Create Visitors Entry", path: "/gate-entry/create-entry-visitors" },
          {
            id: 53,
            label: "Visitors Entry View",
            path: "/gate-entry/view-entry-visitors",
          },
        ],
      },
    ],
  },
  // GATE ENTRY END ==================
];
